import hero from "../../assets/img/hero-img.png";
import Para from "../common/Para";
import CustomButton from "../common/PrimaryBtn";

const Hero = () => {
  return (
    <div>
      <div className="p-5 2xl:p-7">
        <div className="relative sm:rounded-[32px] rounded-[20px] overflow-hidden sm:py-20 py-16 xl:min-h-[60vh] h-[500px] md:h-[656px] flex flex-col justify-center">
          <div className="container sm:px-10 px-5 mx-auto 2xl:max-w-[1240px] relative z-10 ">
            <h2 className=" w-full  text-white  xl:text-[70px] lg:text-[60px] sm:text-[50px] text-[40px] font-bold leading-[110%] xl:max-w-[50%] lg:max-w-[60%] md:mt-10">
              Feel free to travel with us
            </h2>
            <Para
              myClass="text-white mb-7 mt-5 xl:max-w-[40%] lg:max-w-[50%]"
              text="Avoid the hassles and complications — we’re here to make your journey simple, safe, and enjoyable from start to finish."
            />
            <CustomButton text="Explore now" />
          </div>
          <div className="bg-black/30 absolute top-0 left-0 w-full h-full " />
          <img
            className="w-full h-full object-cover object-top  absolute top-0 left-0 z-[-1] pointer-events-none"
            src={hero}
            alt="hero"
          />
        </div>
      </div>
    </div>
  );
};

export default Hero;
